import PropTypes, { InferProps } from 'prop-types';
import {
  useGoogleOneTapLogin,
} from '@react-oauth/google';

const googleOneTapLoginPropertyTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

type GoogleOneTapLoginProperties = InferProps<
typeof googleOneTapLoginPropertyTypes
>;

const GoogleOneTapLogin = ({
  onSuccess,
  onError,
}: GoogleOneTapLoginProperties) => {
  useGoogleOneTapLogin({
    onSuccess,
    onError,
    use_fedcm_for_prompt: true,
  });

  return null;
};

export default GoogleOneTapLogin;
